export interface PlanOptionModel {
  size: number;
  price: number;
}
